import React from "react";
import { DashboardItemValue, DashboardService, OrdersPerCategoryChartDto } from "../../domain";
import { tawreedTranslationService } from "../../../../common/translations";
import { Chart } from "primereact/chart";
import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";
import { TawreedCalendar, TawreedFormField } from "../../../../common/components/form";
import { PrimeIcons } from "primereact/api";
import { DateUtils } from "../../../../helpers/date";
import { AuthUtils } from "../../../auth/domain";
import { Button } from "primereact/button";
import { CategoriesMultiSelect } from "../../../catalog/products/presentaion/components";
import { SalesByCategoryDialog } from "./sales-by-category-dialog";


declare type DashboardOrdersByCategoryChartProps = {

    className: string;

    /**
     *
     */
    loading: boolean;

    /**
     * dto
     */
    dto: OrdersPerCategoryChartDto | undefined;

    /**
     *
     * @param startDate
     * @param endDate
     */
    onSearch(startDate: Date, endDate: Date, categoryIds: number[] | undefined): void;
    // showDetails: (startDate: Date, endDate: Date, categoryIds: number[] | undefined) => void;
    /**
     *
     * @param value
     */
    calculator: (value: DashboardItemValue) => string;
}

declare type DashboardOrdersByCategoryChartState = {
    data: {
        /**
         *
         */
        labels: Array<string>;

        /**
         *
         */
        datasets: Array<{ label: string; backgroundColor: string; data: Array<any>; barThickness?: number, maxBarThickness?: number }>;
    };
    //
    //
        showDetails: boolean,
    startDate: Date;
    endDate: Date;
    categories?: number[];
}

export const DashboardOrdersByCategoryChart: React.FC<DashboardOrdersByCategoryChartProps> = (props) => {

const service = React.useMemo(() => new DashboardService(), []);
    const print = () => {
        return service.print(props.dto?.xlsxReportURI!)
            .then(() => {
            })
            .catch(err => console.error(err));
    };

    const [state, setState] = React.useState<DashboardOrdersByCategoryChartState>({
        data: {
            labels: [],
            datasets: []
        },
        showDetails: false,
        startDate: DateUtils.now(-7),
        endDate: DateUtils.now(),
    });

    React.useEffect(() => {

        let mounted = true;

        if (mounted && !props.loading) {
            props.onSearch(state.startDate, state.endDate, state.categories);
        }

        return () => {
            mounted = false;
        }
    }, [state.startDate, state.endDate, state.categories]);

    React.useEffect(
        () => {
            setState(previous => {
                return {
                    ...previous,
                    data: {
                        labels: props.dto ? props.dto.label : [],
                        datasets: props.dto ? props.dto.datasets.map(value => {
                            return {
                                type: 'bar',
                                label: value.name,
                                backgroundColor: value.color ?? '#FFA726',
                                data: value.values,
                                barThickness: 30,
                                maxBarThickness: 32,
                            }
                        }) : []
                    },
                };
            });
        },
        [props.dto, props.calculator]);

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                align: 'end',
                labels: {
                    font: {
                        family: AuthUtils.current().language === 'ar' ? '--arabic-font-family' : 'var(--font-family)'
                    },
                    color: '#495057'
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    const onChange = (sender: 'startDate' | 'endDate', value: Date) => {
        setState({ ...state, [sender]: value });
    }


    const header = () => {
        return (
            <div className="grid">
                <div className="col-9">
                    <span>
                        {tawreedTranslationService.translate('lbl_orderdashboard_orders_by_category')}
                    </span>

                </div>
                <div className="col-3 sm:col-3">
                    <div className="flex justify-content-start sm:justify-content-end">
                        <Button tooltip={tawreedTranslationService.translate("lbl_details")} icon={PrimeIcons.EYE}
                            onClick={() => setState({...state, showDetails: true})//props.showDetails(state.startDate, state.endDate, state.categories
                            } />
                        <Button tooltip={tawreedTranslationService.translate("lbl_reports_export_as_excel")}
                         icon={PrimeIcons.FILE_EXCEL} className="ml-2"
                            onClick={() => print()
                            } />
                    </div>
                </div>
                <div className="col-12">
                    <div className="grid">
                         <div className="col-6 sm:col-6">
                            <TawreedFormField name="categoryID" title="lbl_category_id">
                                <CategoriesMultiSelect name="categoryID" render="standalone"
                                    value={state.categories}
                                    onChange={e => { setState({ ...state, categories: e.value }) }} />
                            </TawreedFormField>
                        </div>
                        <div className="col-6 sm:col-6">
                            <div className="flex justify-content-start sm:justify-content-end">
                                <i className={"my-auto mr-2 " + PrimeIcons.CALENDAR} style={{ fontSize: '1.5rem' }} />
                                <div style={{ width: '10rem' }}>
                                    <TawreedCalendar render="standalone" disabled={props.loading} value={state.startDate} onChange={e => onChange('startDate', e.value as Date)} />
                                </div>
                                <div style={{ width: '1rem', height: '1rem' }} />
                                <div style={{ width: '10rem' }}>
                                    <TawreedCalendar render="standalone" disabled={props.loading} value={state.endDate} onChange={e => onChange('endDate', e.value as Date)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="grid">
                        {/* <div className="col-6 sm:col-6">
                            <TawreedFormField name="categoryID" title="lbl_category_id">
                                <CategoriesMultiSelect name="categoryID" render="standalone"
                                    value={state.categories}
                                    onChange={e => { setState({ ...state, categories: e.value }) }} />
                            </TawreedFormField>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <Card className={"card " + props.className} header={header()}>
            {
                (props.loading) ? <Skeleton /> : <Chart key="tawreed_dashboard_orders_totals_chart"
                    id="tawreed_dashboard_orders_totals_chart" type="bar" height="16rem" data={state.data}
                    options={options} style={{ width: '100%' }} />
            }
        </Card>
            <SalesByCategoryDialog data={props.dto?.values} visible={state.showDetails} hide={()=>{
                setState({...state, showDetails: false})
            }} xlsxReportURI={props.dto?.xlsxReportURI}
            />
        </React.Fragment>
        
    )
}
